/* Lemyn Track — our own steps (16 Oct 2026). Publishes anonymous custom events to Shopify's pixel bus;
   the lemyn-track web pixel forwards them to our AWS. Only button/link labels and page areas: never what anyone types. */
(function(){
  if (window.__lemynEv) return; window.__lemynEv = 1;
  // "this is me": lemynorganics.com/?lemyn_me=1 marks this browser as ours (never counted); ?lemyn_me=0 undoes it
  try {
    var me = new URLSearchParams(location.search).get('lemyn_me');
    if (me === '1' || me === '0') {
      document.cookie = 'lemyn_internal=' + (me === '1' ? '1' : '0') + ';path=/;max-age=' + (me === '1' ? 157680000 : 0) + ';SameSite=Lax;Secure';
      var n = document.createElement('div');
      n.textContent = me === '1' ? 'This device is now marked as Lemyn. Your visits are not counted.' : 'This device is counted again.';
      n.style.cssText = 'position:fixed;left:16px;right:16px;bottom:24px;z-index:99999;padding:14px 18px;border-radius:14px;background:#E8552F;color:#fff;font:700 15px/1.3 Archivo,Arial,sans-serif;text-align:center';
      (document.body ? Promise.resolve() : new Promise(function(r){ document.addEventListener('DOMContentLoaded', r); })).then(function(){ document.body.appendChild(n); setTimeout(function(){ n.remove(); }, 6000); });
    }
  } catch(e){}
  function pub(n, d){ try{ if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d || {}); }catch(e){} }
  window.lemynTrack = pub;
  function clean(t){ return String(t || '').replace(/\s+/g, ' ').trim().slice(0, 60); }
  function label(el){ return clean(el.getAttribute('aria-label') || el.getAttribute('data-track') || el.innerText || el.title || ''); }
  function area(el){ var s = el.closest('[id]'); return s ? String(s.id).slice(0, 40) : ''; }
  document.addEventListener('click', function(e){
    var el = e.target && e.target.closest && e.target.closest('a,button,[role=button],[role=radio],[role=tab],[role=option],summary,label');
    if (!el) return;
    var d = { label: label(el), area: area(el) };
    if (el.tagName === 'A' && el.href) { try { var u = new URL(el.href, location.href); d.to = (u.host === location.host ? '' : u.host) + u.pathname.slice(0, 80) + (u.hash || '').slice(0, 30); } catch(x){} }
    pub('lemyn_click', d);
  }, true);
  document.addEventListener('change', function(e){
    var el = e.target;
    if (el && el.tagName === 'SELECT') { var o = el.options[el.selectedIndex]; pub('lemyn_choice', { label: clean(o && o.text), area: area(el) }); }
  }, true);
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter') return;
    var el = e.target;
    if (!el || !/^(INPUT|TEXTAREA)$/.test(el.tagName)) return;
    if (/email|tel|password|number/.test(el.type || '')) { pub('lemyn_submit', { field: el.type, area: area(el) }); return; }
    pub('lemyn_ask', { area: area(el) });
  }, true);
})();
